// react
import styled from 'styled-components';
import { Icon, Icons } from '@/components/atoms/Icon';

/**
 * SupportingText provides stylised helper text for form components.
 */
export const SupportingText = ({
  className,
  text,
  icon = 'exclamation-circle',
  size = 'sm',
  ...props
}: SupportingTextProps) => {
  return (
    <StyledContainer className={className} $size={size} {...props}>
      <StyledIcon icon={icon} fontSize={sizeMap[size].iconSize} />
      <StyledSupportingText $size={size}>{text}</StyledSupportingText>
    </StyledContainer>
  );
};

interface StyledContainerProps {
  $size: Size;
}
const StyledContainer = styled.div<StyledContainerProps>`
  display: flex;
  align-items: flex-start;
  gap: ${(props) => props.theme.spacing[sizeMap[props.$size].spacing]};
  color: ${(props) => props.theme.color.neutral[80]};
`;

interface StyledSupportingTextProps {
  $size: Size;
}
const StyledSupportingText = styled.span<StyledSupportingTextProps>`
  // default styles
  font: ${(props) =>
    props.theme.typography.body[sizeMap[props.$size].fontSize].regular};
`;

const sizeMap = {
  sm: {
    fontSize: 'xs',
    iconSize: 12,
    spacing: 8,
  },
  md: {
    fontSize: 'sm',
    iconSize: 20,
    spacing: 12,
  },
};

const StyledIcon = styled(Icon)`
  padding-top: 3px;
`;

type Size = keyof typeof sizeMap;
interface SupportingTextProps {
  className?: string;
  text: string;
  size?: Size;
  icon?: Icons;
}

SupportingText.componentName = 'SupportingText';

export default SupportingText;
